export const COPY: string           = 'copy';
export const EMAIL: string          = 'email';
export const DROPDOWN_ITEM: string  = 'dropdown-item';
export const BUTTON: string         = 'button';
export const LINK: string           = 'link';
export const LABEL: string          = 'label';

